function minBy(array, fn) {
  return array.reduce(
    (acc, value) => ((acc === null || (fn(value) < fn(acc))) ? value : acc),
    null,
  );
}
export default minBy;
